import { css } from "@agapi/ui/panda/css";
export const sectionStyles = css.raw({
    px: 'app',
    overflowX: 'hidden',
    width: '100%',
    justifyContent: 'center',
    paddingTop: "normal",
    paddingBottom: "normal",
});
export const containerBaseStyles = css.raw({
    display: 'flex',
    flexDirection: 'column',
    gap: '3',
    px: 0,
});
